





















































































import { Expression, ExpressionMap, NoExpression, ObjectExpression } from 'expangine-runtime';
import { obj } from '@/common';
import { Preferences, PreferenceCategory } from '@/app/Preference';
import { ShortcutContext } from '@/app/Shortcuts';
import ExpressionBase from '../ExpressionBase';


const PREF_SHORTCUT_OBJECT_ADD = Preferences.define({
  key: 'shortcut_object_add',
  label: 'Add Object expression property shortcut',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.SHORTCUT],
  defaultValue: '187__c',
  component: 'ex-shortcut-input',
});


export default ExpressionBase<ObjectExpression>().extend({
  name: 'ObjectEditor',
  data: () => ({
    sorting: false,
  }),
  computed: {
    keys: {
      get(): string[] {
        return Object.keys(this.value.props);  
      },
      set(keys: string[]) {
        const props: ExpressionMap = obj();
        for (const key of keys) {
          props[key] = this.value.props[key];
        }
        this.value.props = props;
        this.update();
      },
    },
    hasProperties(): boolean {
      return this.keys.length > 1;
    },
    objectShortcuts(): ShortcutContext {
      return { 
        downs: {
          [Preferences.get(PREF_SHORTCUT_OBJECT_ADD)]: this.addProperty,
        },
      };
    },
    tableClasses(): string {
      return this.readOnly ? 'ex-expression ex-curly-braces' : '';
    },
  },
  mounted() {
    this.addIfEmpty();
  },
  methods: {
    addProperty(): void {
      this.$set(this.value.props, this.getNextPropertyName(), NoExpression.instance);
    },
    getNextPropertyName(): string {
      const names = 'abcdefghijklmnopqrstuvwxyz'.split('');
      let next = names.find((name) => !this.hasProperty(name));
      if (!next) {
        let index = 0;
        next = 'temp';
        while (this.hasProperty(next)) {
          next = 'temp' + index;
          index++;
        }
      }
      return next;
    },
    addIfEmpty(): void {
      if (Object.keys(this.value.props).length === 0) {
        this.addProperty();
      }
    },
    toggleSort() {
      this.sorting = !this.sorting;
    },
    hasProperty(name: string) {
      return !!(this.value && this.value.props && this.value.props[name]);
    },
    isPropertyInvalid(prop: string): boolean {
      return !prop;
    },
    changePropertyExpression(prop: string, expr: Expression): void {
      this.$set(this.value.props, prop, expr);
      this.update();
    },
    changeProperty(oldProp: string, newProp: string): void {
      const oldProps = this.value.props;
      const newProps: ExpressionMap = {};

      for (const currentProp in oldProps) {
        newProps[currentProp === oldProp 
          ? newProp 
          : currentProp] = oldProps[currentProp];
      }

      this.value.props = newProps;
      this.update();
    },
    removeProperty(prop: string): void {
      this.$delete(this.value.props, prop);
      this.update();
    },
  },
});
